<div class="rx-app-flex-container-column">
    <div class="rx-app-flex-container-row" [class.general-order-info__row--column-sm]="isResponsive">
        <rx-info-block
            class="info-box general-order-info__procedure"
            [class.general-order-info__procedure--responsive]="isResponsive"
            [fields]="[
            {
                name: 'GeneralRxData.Procedure',
                id: 'general-procedure',
                value: rx?.Order?.ProcedureId | mapper: getProcedureDescription: rxConfig?.Procedures,
                isInline: true
            }
        ]"
        ></rx-info-block>
        <div class="rx-separator vertical transparent" [class.general-order-info__separator--sm]="isResponsive"></div>
        <rx-info-block
            class="info-box rx-app-flex"
            [fields]="[
            {
                name: 'GeneralRxData.ProcedureType',
                id: 'general-procedure-type',
                value: rx?.Order?.ProcedureTypeId | mapper: getTypeDescription: rxConfig?.Types,
                isInline: true
            }
        ]"
        ></rx-info-block>
    </div>
    <div class="rx-separator horizontal"></div>
    <div class="rx-app-flex-container-row" [class.general-order-info__row--column-md]="isResponsive">
        <rx-info-block
            class="info-box general-order-info__order-fields rx-app-flex-container-column"
            [fields]="isRxForModelingContext | mapper : getFields : rx"
        ></rx-info-block>
        <div class="rx-separator vertical" [class.general-order-info__separator--md]="isResponsive"></div>
        <div class="rx-app-flex rx-app-flex-container-row" [class.general-order-info__row--column-sm]="isResponsive">
			<div
				class="general-order-info__scan-fields rx-app-flex-container-row"
				[class.general-order-info__scan-fields--responsive]="isResponsive"
			>
				<rx-info-block
					class="info-box rx-app-flex-container-column"
					[fields]="isDueDateVisible | mapper : getScanAndStatusFields : rx : dateFormat"
				></rx-info-block>
				<rx-info-block
					class="info-box rx-app-flex-container-column"
					style="padding-left: 0"
					*ngIf="(scannerInfo?.scannerModelDescription | scannerModel) as scannerModelValue"
					[fields]="[{
				name: 'GeneralRxData.ScannerModel',
				id: 'general-scanner-model',
				value: scannerModelValue
			}]"
				></rx-info-block>
			</div>
            <div class="rx-separator vertical" [class.general-order-info__separator--sm]="isResponsive"></div>
            <rx-info-block
                class="info-box rx-app-flex rx-app-flex-container-column"
                [fields]="[
            { name: 'GeneralRxData.Signature', id: 'general-signature', value: rx?.Signature, isSignature: true },
            { name: 'GeneralRxData.License', id: 'general-license', value: rx?.Doctor?.Licence }
        ]"
            ></rx-info-block>
        </div>
    </div>
</div>
